// The school's social accounts. Fill in `url` (and the display name/handle)
// for each platform the school actually uses. A platform with an empty `url`
// is hidden everywhere: the navbar icons, the mobile menu, and the homepage
// "Follow Our Story" band. If both are empty, none of them render.
const social = {
  instagram: {
    url: 'https://www.instagram.com/lexingtonacademy/',
    handle: '@lexingtonacademy'
  },
  facebook: {
    url: '',     // e.g. 'https://www.facebook.com/yourschool'
    name: ''     // e.g. 'Lexington Academy'
  }
};

export default social;
